import ctl from '@netlify/classnames-template-literals'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { NewOptionIcon, NewQuestionIcon } from './icons'

export const NewQuestionButton = memo(function NewQuestionButton({ onClick }: { onClick: () => void }) {
	const { t } = useTranslation('common')
	return (
		<button
			className="cursor-pointer absolute inset-0 flex items-center justify-center group/button"
			onClick={onClick}
			type="button"
		>
			<span className="absolute inset-x-0 h-[2px] group-hover/form:bg-grey-50 group-hover/button:!bg-purple-500 transition-colors block" />
			<div
				className={ctl(`
				cursor-pointer relative bg-white p-2 text-purple-500 text-xs opacity-0 inline-flex items-center gap-1
				transition-opacity
				duration-200
				group-hover/button:opacity-100
			`)}
			>
				<NewQuestionIcon />
				<span className="">{t('editor.formSimulator.newQuestion')}</span>
			</div>
		</button>
	)
})

export const NewOptionButton = memo(function NewOptionButton({ onClick }: { onClick: () => void }) {
	const { t } = useTranslation('common')
	return (
		<button
			className="cursor-pointer absolute inset-0 flex items-center justify-center group/button"
			onClick={onClick}
			type="button"
		>
			<span className="absolute inset-x-0 h-[2px] group-hover/question:bg-grey-50 group-hover/button:!bg-purple-500 transition-colors block" />
			<div
				className={ctl(`
					cursor-pointer relative bg-white p-2 text-purple-500 text-xs opacity-0 inline-flex items-center gap-1
					transition-opacity
					duration-200
					group-hover/button:opacity-100
				`)}
			>
				<NewOptionIcon />
				<span className="">{t('editor.formSimulator.newOption')}</span>
			</div>
		</button>
	)
})
